import React from 'react'
import style from "../Home.module.css";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import Util from "../../../utils/utils";
import SiteInfo from "./SiteInfo";
import {message} from "antd";
import PermissionUtils from "../../../utils/permissionUtils";

class Site extends React.Component {
    componentDidMount() {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (Util.isEmpty(userName)) {
            this.props.history.push("/login")
        } else {
            let userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
            if (userRole !== 0 && userRole !== 1) {
                message.error("你没有权限访问!");
                this.props.history.push("/home");
            } else {
                // 线上电呼(role=1)只读访问，无需权限码校验；管理员走权限码校验
                if (userRole === 0) {
                    PermissionUtils.getUserPermission(this,'100002');
                }
            }
        }
    }

    render() {
        return (
            <div className={style['home']}>
                <Header history={this.props.history}/>
                <LeftMenu history={this.props.history}/>
                <SiteInfo history={this.props.history}/>
            </div>
        )
    }
}

export default Site;